module.exports = __webpack_public_path__ + "img/ic_mainservice_internet_header.a4b4f6ad.svg";